/**
 * Copyright (C) 2021 Prosperia Salud, S.A. DE C.V. info@prosperia.health.
 * All rights reserved
 * DO NOT REDISTRIBUTE
 * The software MAY NOT be rewritten or refactored by any means. The code MAY
 * NOT be packaged and redistributed by any means without prior written
 * permission from the author.
 */
import React from 'react';
import ReactDOM from 'react-dom';
/// /// EXTERNAL /// ///
// third party libraries //
// import * as Sentry from '@sentry/react';
import { BrowserRouter } from 'react-router-dom';
import '@fontsource/plus-jakarta-sans/200.css';
import '@fontsource/plus-jakarta-sans/300.css';
import '@fontsource/plus-jakarta-sans/400.css';
import '@fontsource/plus-jakarta-sans/500.css';
import '@fontsource/plus-jakarta-sans/600.css';
import '@fontsource/plus-jakarta-sans/700.css';
import '@fontsource/plus-jakarta-sans/800.css';

/// /// INTERNAL /// ///
// components //
import Interceptors from 'components/atoms/common/Interceptors';
// import Clarity from 'components/pages/Clarity';
// context //
import { SearchProvider } from 'context/SearchContext';
import { AuthProvider } from 'context/AuthContext';
import { ErrorProvider } from 'context/ErrorContext';

import App from './App';
// utils //
import 'utils/i18n';
import './index.css';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// The app is served both under PUBLIC_URL (/retinia) and at the root (/),
// so the router basename must follow the URL used to enter the app.
const { PUBLIC_URL } = process.env;
const publicUrl = window.location.pathname.startsWith(PUBLIC_URL) ? PUBLIC_URL : '/';
// const sentryDns = process.env.REACT_APP_SENTRY_DNS;
// const isProduction = process.env.REACT_APP_STAGE === 'production';

// if (isProduction) {
//   Sentry.init({
//     dsn: sentryDns,
//     integrations: [
//       // Sentry.browserTracingIntegration(),
//       Sentry.replayIntegration(),
//     ],
//     environment: process.env.REACT_APP_STAGE,
//     // tracesSampleRate: 1.0,
//     // replaysSessionSampleRate: 0.1,
//     replaysOnErrorSampleRate: 1.0,
//   });
// }

ReactDOM.render(
  // <Sentry.ErrorBoundary>
  <ErrorProvider>
    <BrowserRouter basename={publicUrl}>
      <AuthProvider>
        <SearchProvider>
          <Interceptors />
          {/* {isProduction && <Clarity />} */}
          <App />
        </SearchProvider>
      </AuthProvider>
    </BrowserRouter>
  </ErrorProvider>,
  // </Sentry.ErrorBoundary>,
  document.getElementById('root'),
);

// TODO remove when set SW
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
